import { css } from 'emotion'

export const SelectInputFieldStyles = css`
  > label {
    display: block;
  }

  .ErrorMessage {
    margin-top: 8px;
  }
`
